import { formatDate } from 'lib/helpers/dateUtils';

export const getTimezoneLabel = (value, isTimezone, timezone) => {
  if (!isTimezone || !timezone) return;
  const isDateLikeValue =
    value instanceof Date || (typeof value === 'string' && value.includes('T'));
  const dateForTimezone = isDateLikeValue ? new Date(value) : new Date();

  return formatDate(dateForTimezone, timezone, 'zzz');
};
